<txtb-drawer
  #drawer
  (contentCollapse)="controlAudioPlayback(!$event)"
  [actionId]="action.id"
  [textbookPageId]="action.textbookPageId"
  [textbookId]="action.textbookId"
  [groupInfo]="groupInfo"
>
  <div main class="audio-wrapper">
    <txtb-media-player
      class="audio-player"
      [class.is-disabled]="drawer.contentCollapse | async"
      [playerLayout]="playerLayout"
      [playback$]="updatePlayback$ubject.asObservable()"
      [currentTime$]="updateCurrentTime$ubject.asObservable()"
      [controlsVisibility$]="updateControlsVisibility$ubject.asObservable()"
      [options]="audioOptions"
      [volume$]="updateVolume$ubject.asObservable()"
      (playerOnAfterViewInit)="onPlayerAfterViewInit()"
      (playerOnLoadedData)="onPlayerLoadedData()"
      (playerOnVolumeChange)="onPlayerVolumeChange($event)"
      (playerOnTimeUpdate)="onMediaCurrentTimeChange($event)"
      (playerOnPlaybackChange)="onPlayerPlaybackChange($event)"
      (playerOnEnded)="onPlayerEnded()"
    >
    </txtb-media-player>

    <div *ngIf="action.meta.image" class="poster-wrapper">
      <txtb-image-wrapper
        [imageData]="action.meta.image"
        [scrollDisabled]="(drawer?.drawingByPointerMove$ | async) === true"
        [imagesScalingEnabled]="!!action.meta?.imagesScalingEnabled"
        [percentageScale]="action.meta.image?.percentageScale || null"
        [horizontalScroll]="action.meta.image?.horizontalScroll"
        [verticalScroll]="action.meta.image?.verticalScroll"
        style="height: 100%; width: 100%"
      ></txtb-image-wrapper>
    </div>

    <div class="collapsed-audio-icon-wrapper">
      <txtb-icons
        type="audioPlayer"
        class="collapsed-icon"
        [class.is-placeholder]="!action.meta.image?.resourceId"
      >
      </txtb-icons>
    </div>
  </div>
</txtb-drawer>
